
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1602Grid extends Serenity.EntityGrid<Report_1602Row, any> {
        protected getColumnsKey() { return Report_1602Columns.columnsKey; }
        protected getDialogType() { return Report_1602Dialog; }
        protected getIdProperty() { return Report_1602Row.idProperty; }
        protected getInsertPermission() { return Report_1602Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1602Row.localTextPrefix; }
        protected getService() { return Report_1602Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)
        
           let descriptions: string[] = [];
        //    let shop = QRreport.QRywcSpecRow.getLookup().itemById["20"].ShopId;
            let find = QRreport.QRywcSpecRow.getLookup().itemById["61"].DayOfWeek;
            
            let startDate = QRreport.QRywcSpecRow.getLookup().itemById["61"].DateBegin;
            let endDate = QRreport.QRywcSpecRow.getLookup().itemById["61"].DateEnd;
            let qstartDate = Q.formatDate(startDate, "dd/MM/yyyy")
            let qendDate = Q.formatDate(endDate, "dd/MM/yyyy")
            var a = ""
            a = "ระหว่างวันที่ " + qstartDate + " - " + qendDate

            var b = ""
            if (find != null) {
                let pos = Supplier.CsSupplierRow.getLookup().itemById[find].SupplName;
                b = a + "  ระบุผู้จำหน่าย "  + pos
           
            } else {
           
                b = a
           
            }

            descriptions.push(b);
            
            return [descriptions, gridColumns];
        }

        protected createQuickSearchInput() {
        }
        
        protected getColumns() {
            var columns = super.getColumns();
        
            return columns;
        }
        
        protected usePager() {
            return false;
        }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
            groupingMixin.plugin.setDroppedGroups(["SupplId"]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();
            
        }

        protected getButtons() {
            var buttons = super.getButtons();
        
            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
        
            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1602Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
        
            // let reportTitle = 'รายงานสรุปยอดขายสินค้ารับฝากขาย&สินค้า'
        
            // // Max page width = 277
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     // 0: { field: "ShopName", title: "ร้านค้า[Id]", cellWidth: 50 ,isHidden:true},
            //     0: { field: "SupplFullName", title: "ผู้จำหน่าย [Id.]", cellWidth: 38 },
            //     // 2: { field: "ShopId", title: "ร้านค้า", cellWidth: 15 ,isHidden:true},
            //     1: { field: "PluFullName", title: "ชื่อสินค้า [รหัส PLU]", cellWidth: 44 ,isHidden:true},
            //     2: { field: "Qty", title: "จำนวน", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     3: { field: "UnitPrice", title: "ราคา/หน่อย", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     4: { field: "GrossSales", title: "ยอดขาย(ก่อนGP)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     5: { field: "NetsalesafterGp", title: "ยอดขาย(หลังGP)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     6: { field: "GpPc", title: "% GP", cellWidth: 30,halign: 'center'},
            //     7: { field: "Gpamt", title: "GP Amt", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     8: { field: "ItemPromoId", title: "Pm. Code", cellWidth: 30,halign: 'right',aggregate:"sum"},
            // }
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
        
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1602/edit/61';
                        return false;
                    },
                }
            );
        
            return buttons;
        }
    }
}